import React, { useState } from "react";
import { Routes, Route, Navigate } from "react-router";
import {
  ThemeProvider,
  StyledEngineProvider,
  styled,
  CustomTheme,
} from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import lumonusTheme from "components/themes/Lumonus/theme";

import CareplanCreatorFormApollo from "pages/CareplanCreatorFormApollo";
import CareplanSearch from "pages/search/CareplanSearch";
import ProtocolSearch from "pages/search/ProtocolSearch";
import Formulary from "pages/Formulary";
import BulkEdit from "pages/bulkEdit/BulkEdit";
import Template from "pages/Template";
import TopNav from "./components/base/TopNav";
import ProtectedRoute from "./components/ProtectedRoute";
import { ThemeContext } from "contexts/ThemeContext";
import Blueprint from "pages/Blueprint";
import { TenantConfigProvider } from "contexts/TenantConfigContext";

const PageContainer = styled("div")`
  overflow-y: hidden;
  flex-wrap: wrap;
`;

const RouteContainer = styled("div")`
  height: calc(100vh - 56px);
  width: 100%;
`;

const PageMessage = styled("h1")`
  margin-top: 70px;
`;

const ValidUserComponent = () => (
  <PageContainer>
    <TopNav />
    <RouteContainer>
      <Routes>
        <Route path="/protocol_search" element={<ProtocolSearch />} />
        <Route path="/formulary" element={<Formulary />} />
        <Route key="search" path="/search" element={<CareplanSearch />} />
        <Route key="review" path="/review/*" element={<CareplanSearch />} />
        <Route
          path="/template/:templateId"
          element={
            <TenantConfigProvider>
              <Template />
            </TenantConfigProvider>
          }
        />
        <Route
          path="/bulk_edit/:templateId/:form/:groupId/*"
          element={<BulkEdit />}
        />
        <Route
          path="/template/:templateId/*"
          element={
            <TenantConfigProvider>
              <CareplanCreatorFormApollo />
            </TenantConfigProvider>
          }
        />
        <Route path="/blueprint/*" element={<Blueprint />} />
        <Route path="/" element={<Navigate to="/search" replace />} />
      </Routes>
    </RouteContainer>
  </PageContainer>
);

const ErrorTest = () => {
  throw new Error("Manual error triggered, please contact support");
};

const App = (): React.ReactElement => {
  const [theme, setTheme] = useState(lumonusTheme);

  const setThemeAndTitle = (theme: CustomTheme) => {
    setTheme(theme);
    document.title = theme.custom.title;
  };

  return (
    <StyledEngineProvider injectFirst>
      <ThemeContext.Provider value={{ theme, setTheme: setThemeAndTitle }}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Routes>
            <Route path="/error" element={<ErrorTest />} />
            <Route
              path="/notauthorized"
              element={
                <div>
                  <TopNav />
                  <PageMessage>Not Authorized for this application</PageMessage>
                </div>
              }
            />
            <Route
              path="/logout"
              element={
                <div>
                  <TopNav />
                  <PageMessage>User logged out</PageMessage>
                </div>
              }
            />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <ValidUserComponent />
                </ProtectedRoute>
              }
            />
          </Routes>
        </ThemeProvider>
      </ThemeContext.Provider>
    </StyledEngineProvider>
  );
};

export default App;
